module.exports = __webpack_public_path__ + "img/ikan-galau-2.17a5ca34.svg";